import { action } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { PillSuggestion, SubstrateSearchSuggestionSegment } from 'owa-search-service';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';
import { addDatapointConfig } from 'owa-analytics-actions';

export const addSuggestionPillInternal = action(
    'ADD_SUGGESTION_PILL_INTERNAL',
    (suggestionPill: PillSuggestion, scenarioId: SearchScenarioId) => ({
        suggestionPill,
        scenarioId,
    })
);

export const ghostTextAccepted = action('GHOST_TEXT_ACCEPTED', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));

export const initializeScenarioStore = action(
    'INITIALIZE_SCENARIO_STORE',
    (scenarioId: SearchScenarioId, isUsing3S: boolean) => ({
        scenarioId,
        isUsing3S,
    })
);

export const onBackspacePressedSearchInput = action(
    'ON_BACKSPACE_PRESSED_SEARCH_INPUT',
    (cursorPosition: number, scenarioId: SearchScenarioId) => ({ cursorPosition, scenarioId })
);

export const onDownArrowPressedSearchInput = action(
    'ON_DOWN_ARROW_PRESSED_SEARCH_INPUT',
    (scenarioId: SearchScenarioId) => ({
        scenarioId,
    })
);

export const onEnterPressedSearchInput = action(
    'ON_ENTER_PRESSED_SEARCH_INPUT',
    (
        selectedSuggestionIndex: number,
        searchInputValue: string,
        isAutocompleteTextVisible: boolean,
        scenarioId: SearchScenarioId
    ) => ({
        selectedSuggestionIndex,
        searchInputValue,
        isAutocompleteTextVisible,
        scenarioId,
    })
);

export const onEscapePressedSearchInput = action(
    'ON_ESCAPE_PRESSED_SEARCH_INPUT',
    (scenarioId: SearchScenarioId) => ({ scenarioId })
);

export const onKeyDownSearchInput = action(
    'ON_KEY_DOWN_SEARCH_INPUT',
    (evtKeyCode: number, scenarioId: SearchScenarioId) => ({
        evtKeyCode,
        scenarioId,
    })
);

export const onLeftArrowPressedSearchInput = action(
    'ON_LEFT_ARROW_PRESSED_SEARCH_INPUT',
    (cursorPosition: number, scenarioId: SearchScenarioId) => ({ cursorPosition, scenarioId })
);

export const onResize = action(
    'ON_RESIZE_SUGGESTIONSCALLOUT',
    (searchBoxWidth: number, scenarioId: SearchScenarioId) => ({ searchBoxWidth, scenarioId })
);

export const onRightArrowPressedSearchInput = action(
    'ON_Right_ARROW_PRESSED_SEARCH_INPUT',
    (scenarioId: SearchScenarioId) => ({ scenarioId })
);

export const onSearchInputFocused = action(
    'ON_SEARCH_INPUT_FOCUSED',
    (scenarioId: SearchScenarioId) =>
        addDatapointConfig({ name: 'ON_SEARCH_INPUT_FOCUSED' }, { scenarioId })
);

export const onUpArrowPressedSearchInput = action(
    'ON_UP_ARROW_PRESSED_SEARCH_INPUT',
    (scenarioId: SearchScenarioId) => ({ scenarioId })
);

export const removeParameterPillFromStore = action(
    'REMOVE_PARAMETER_PILL_FROM_STORE',
    (scenarioId: SearchScenarioId) => ({
        scenarioId,
    })
);

export const removeSuggestionPillFromSearchBox = action(
    'REMOVE_SUGGESTION_PILL_FROM_SEARCHBOX',
    (suggestionPillId: string, scenarioId: SearchScenarioId, actionSource: string) => ({
        suggestionPillId,
        scenarioId,
        actionSource,
    })
);

export const removeSuggestionPillFromStore = action(
    'REMOVE_SUGGESTION_PILL_FROM_STORE',
    (suggestionPillId: string, suggestionPillIndex: number, scenarioId: SearchScenarioId) => ({
        suggestionPillId,
        suggestionPillIndex,
        scenarioId,
    })
);

export const removeSuggestionSegmentFromSearchBox = action(
    'REMOVE_SUGGESTION_SEGMENT_FROM_SEARCHBOX',
    (segmentKey: string, scenarioId: SearchScenarioId) => ({
        segmentKey,
        scenarioId,
    })
);

export const removeSuggestionSegmentFromSearchBoxInternal = action(
    'REMOVE_SUGGESTION_SEGMENT_FROM_SEARCHBOX_INTERNAL',
    (segmentKey: string, scenarioId: SearchScenarioId) => ({
        segmentKey,
        scenarioId,
    })
);

export const resetSearchStore = action('RESET_SEARCH_STORE', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));

export const setSearchText = action(
    'SET_SEARCH_TEXT',
    (searchText: string, scenarioId: SearchScenarioId) => ({
        searchText,
        scenarioId,
    })
);

export const setSelectedPillIndex = action(
    'SET_SELECTED_PILL_INDEX',
    (selectedPillIndex: number, scenarioId: SearchScenarioId) => ({
        selectedPillIndex,
        scenarioId,
    })
);

export const setSelectedSuggestionIndex = action(
    'SET_SELECTED_SUGGESTION_INDEX',
    (selectedSuggestionIndex: number, scenarioId: SearchScenarioId) => ({
        selectedSuggestionIndex,
        scenarioId,
    })
);

export const setSuggestionPillIds = action(
    'SET_SUGGESTION_PILL_IDS',
    (suggestionPillIds: string[], scenarioId: SearchScenarioId) => ({
        suggestionPillIds,
        scenarioId,
    })
);

export const setSuggestionPills = action(
    'SET_SUGGESTION_PILLS',
    (suggestionPills: ObservableMap<string, PillSuggestion>, scenarioId: SearchScenarioId) => ({
        suggestionPills,
        scenarioId,
    })
);

export const setSuggestionSegmentsInternal = action(
    'SET_SUGGESTION_SEGMENTS_INTERNAL',
    (segments: SubstrateSearchSuggestionSegment[], scenarioId: SearchScenarioId) => ({
        segments,
        scenarioId,
    })
);

export const updateGhostText = action('UPDATE_GHOST_TEXT', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));

export const updateIsSuggestionSetCompleteInternal = action(
    'UPDATE_IS_SUGGESTION_SET_COMPLETE_INTERNAL',
    (isComplete: boolean, scenarioId: SearchScenarioId) => ({
        isComplete,
        scenarioId,
    })
);

export const onSuggestionsCalloutPositioned = action(
    'ON_SUGGESTIONS_CALLOUT_POSITIONED',
    (scenarioId: SearchScenarioId) => ({
        scenarioId,
    })
);

export const onSuggestionsCalloutWillUnmount = action(
    'ON_SUGGESTIONS_CALLOUT_WILL_UNMOUNT',
    (scenarioId: SearchScenarioId) => ({
        scenarioId,
    })
);
